import { render, staticRenderFns } from "./prepaidItem.vue?vue&type=template&id=59452a00&"
import script from "./prepaidItem.vue?vue&type=script&lang=js&"
export * from "./prepaidItem.vue?vue&type=script&lang=js&"
import style0 from "./prepaidItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports